// extracted by css-extract-rspack-plugin
export default {"tag":"tag-BMgtMv","label":"label-zjTH8M","swatch":"swatch-JWniIW","close":"close-nlCSB4"};